import { RG_TYPE as a, isPolygonClosed as r } from "@project-rouge/rg-core";
import { getBuildingBoundary as l } from "../../3d/boundary/index5.js";
function f(t) {
  const n = t.children.filter((o) => o.type === a.Facade);
  let e = [];
  return n.length > 0 ? e = l(t, t.data.levels.map((o) => o.levelIndex), [a.Facade]) : e = l(t, t.data.levels.map((o) => o.levelIndex)), e.length === 0 ? [] : (e = r(e) ? e : e.concat([e[0]]), e);
}
export {
  f as getBuildingProjectionPolygon
};
//# sourceMappingURL=index3.js.map
